import React from 'react';
import { Card, Col, Row, Statistic, Divider } from 'antd';
import { currencyFormat } from '../../utils/helper';

const Analytics = ({ data, tierData }) => {
  const renderTierStats = (title, stats) => (
    <div key={title} style={{ marginBottom: '20px' }}>
      <Divider orientation="left">{title}</Divider>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Card size="small">
            <Statistic title="Tier 1" value={stats.tier1} suffix={`(${currencyFormat(stats.tier1Amount)})`} />
          </Card>
        </Col>
        <Col span={8}>
          <Card size="small">
            <Statistic title="Tier 2" value={stats.tier2} suffix={`(${currencyFormat(stats.tier2Amount)})`} />
          </Card>
        </Col>
        <Col span={8}>
          <Card size="small">
            <Statistic title="Tier 3" value={stats.tier3} suffix={`(${currencyFormat(stats.tier3Amount)})`} />
          </Card>
        </Col>
        <Col span={8}>
          <Card size="small">
            <Statistic title="Tier 4" value={stats.tier4} suffix={`(${currencyFormat(stats.tier4Amount)})`} />
          </Card>
        </Col>
        <Col span={8}>
          <Card size="small" style={{ background: '#f5f5f5' }}>
            <Statistic
              title="Category Total"
              value={stats.total}
              suffix={`(${currencyFormat(stats.totalAmount)})`}
              valueStyle={{ fontWeight: 'bold' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );

  return (
    <div style={{ marginBottom: '20px' }}>
      <Divider orientation="left">System Transaction Overview</Divider>
      {data && (
        <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
          <Col span={8}>
            <Card>
              <Statistic
                title="Total Transactions"
                value={data.totalTransactions}
                valueStyle={{ color: '#3f8600' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="Successful Transactions"
                value={data.successfulTransactions}
                valueStyle={{ color: '#3f8600' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="Pending Transactions"
                value={data.pendingTransactions}
                valueStyle={{ color: '#fadb14' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="Failed Transactions"
                value={data.failedTransactions}
                valueStyle={{ color: '#cf1322' }}
              />
            </Card>
          </Col>
        </Row>
      )}

      {tierData && (
        <>
          {tierData.personal && renderTierStats('Personal Accounts', tierData.personal)}
          {tierData.nonCac && renderTierStats('Non-CAC Business Accounts', tierData.nonCac)}
          {tierData.cac && renderTierStats('CAC Business Accounts', tierData.cac)}

          <Divider orientation="left">Overall Cumulative Summary</Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Card style={{ textAlign: 'center', background: '#e6f7ff' }}>
                <Statistic
                  title="Total Accounts across all categories"
                  value={tierData.total}
                  valueStyle={{ color: '#1890ff', fontSize: '24px' }}
                />
              </Card>
            </Col>
            <Col span={12}>
              <Card style={{ textAlign: 'center', background: '#f9f0ff' }}>
                <Statistic
                  title="Total Amount across all categories"
                  value={currencyFormat(tierData.totalAmount)}
                  valueStyle={{ color: '#722ed1', fontSize: '24px' }}
                />
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default Analytics;